import { motion } from 'framer-motion';

const COLORS: Record<string, string> = {
  Open: '#94a3b8',
  'In Progress': '#f59e0b',
  Done: '#26a698',
};

export function StatusBreakdownChart({ data }: { data: { status: string; count: number }[] }) {
  const total = data.reduce((sum, d) => sum + d.count, 0) || 1;

  return (
    <div className="space-y-3">
      <div className="flex h-3 w-full overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
        {data.map((d) => (
          <motion.div
            key={d.status}
            initial={{ width: 0 }}
            animate={{ width: `${(d.count / total) * 100}%` }}
            transition={{ duration: 0.5, ease: 'easeOut' }}
            style={{ backgroundColor: COLORS[d.status] ?? '#94a3b8' }}
          />
        ))}
      </div>
      <div className="flex flex-wrap gap-x-5 gap-y-1.5">
        {data.map((d) => (
          <div key={d.status} className="flex items-center gap-1.5 text-xs text-slate-500 dark:text-slate-400">
            <span className="h-2 w-2 rounded-full" style={{ backgroundColor: COLORS[d.status] ?? '#94a3b8' }} />
            {d.status} <span className="font-semibold text-slate-700 dark:text-slate-300">{d.count}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
